// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DeprecationModalController from "./deprecation_modal_controller"
application.register("deprecation-modal", DeprecationModalController)

import DisplayNameModalController from "./display_name_modal_controller"
application.register("display-name-modal", DisplayNameModalController)

import EmailTemplatePreviewController from "./email_template_preview_controller"
application.register("email-template-preview", EmailTemplatePreviewController)

import ExternalLinksController from "./external_links_controller"
application.register("external-links", ExternalLinksController)

import FileUploadPreviewController from "./file_upload_preview_controller"
application.register("file-upload-preview", FileUploadPreviewController)

import GalleryManagerController from "./gallery_manager_controller"
application.register("gallery-manager", GalleryManagerController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HistoryBackController from "./history_back_controller"
application.register("history-back", HistoryBackController)

import OtherAudienceController from "./other_audience_controller"
application.register("other-audience", OtherAudienceController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import SaveTaskController from "./save_task_controller"
application.register("save-task", SaveTaskController)

import Scheduling__AvailabilityController from "./scheduling/availability_controller"
application.register("scheduling--availability", Scheduling__AvailabilityController)

import Scheduling__BookingController from "./scheduling/booking_controller"
application.register("scheduling--booking", Scheduling__BookingController)

import Scheduling__DefaultCalendarController from "./scheduling/default_calendar_controller"
application.register("scheduling--default-calendar", Scheduling__DefaultCalendarController)

import Scheduling__MeetingTypeController from "./scheduling/meeting_type_controller"
application.register("scheduling--meeting-type", Scheduling__MeetingTypeController)

import SignInToggleController from "./sign_in_toggle_controller"
application.register("sign-in-toggle", SignInToggleController)

import TestimonialCarouselController from "./testimonial_carousel_controller"
application.register("testimonial-carousel", TestimonialCarouselController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import WordCounterController from "./word_counter_controller"
application.register("word-counter", WordCounterController)
